/**
 * GEAO flow types
 */
export const FlowType = Object.freeze({
    Principal: 'principal',
    Producer: 'producer'
});